import { Editor, Node } from "slate";

export const isEditorContentEmpty = (editor: Editor): boolean => {
  const { children } = editor;

  // Check if the editor only contains empty text nodes
  if (children.length === 1) {
    const firstNode = children[0];
    if (firstNode && Node.string(firstNode).trim() === "") {
      return true;
    }
  }

  // Check if all children are empty
  return children.every((child) => Node.string(child).trim() === "");
};
